import script from "./LearnerDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./LearnerDashboard.vue?vue&type=script&setup=true&lang=js"

import "./LearnerDashboard.vue?vue&type=style&index=0&id=411e60fb&lang=css"

const __exports__ = script;

export default __exports__